export const ds_FormBlock_Entry = `
    fragment ds_FormBlock_Entry on ds_FormBlock_Entry {
        id
        canonicalUid

        form_ContainerWidth
        form_ColorPalette
        form_ColorTheme
        form_TopSpacing
        form_FullWidthBackground

        form_Heading
        form_BodyText
        form_Form {
            id
            fields
            settings
        }
        form_RedirectOnSubmit {
            url
        }
    }
`